<template>
  <div class="stakeholders pad">
    <div class="top">
      <h3 class="title">{{ $t('about-who-stakeholder') }}</h3>
    </div>
    <div class="row">
      <div class="col-5">
        <div class="list">
          <h4>{{ stakeholders[0].name[$i18n.locale] }}</h4>
          <ul>
            <li class="tx-wg-bold" v-for="(item, id) in stakeholders[0].list.filter((el) => el.title[$i18n.locale])" :key="id">
              {{item.title[$i18n.locale] }}
            </li>
          </ul>
        </div>
        <div class="list">
          <h4>{{ stakeholders[2].name[$i18n.locale] }}</h4>
          <ul>
            <li class="tx-wg-bold" v-for="(item, id) in stakeholders[2].list.filter((el) => el.title[$i18n.locale])" :key="id">
              {{item.title[$i18n.locale] }}
            </li>
          </ul>
        </div>
      </div>
      <div class="col-5">
        <div class="list">
          <h4>{{ stakeholders[1].name[$i18n.locale] }}</h4>
          <ul>
            <li class="tx-wg-bold" v-for="(item, id) in stakeholders[1].list.filter((el) => el.title[$i18n.locale])" :key="id">
              {{item.title[$i18n.locale] }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stakeholders',
  computed: {
    stakeholders() {
      return this.$store.getters['stakeholders/list'];
    }
  }
};
</script>

<style lang="scss" scoped>
.stakeholders {
  width: 100%;
  height: 100%;
  background-color: $col-blue-light;
  color: $col-white;
  overflow-y: scroll;
  .top {
    margin-bottom: $padding;
    @media screen and (max-width: $mq-mobile) {
      margin-bottom: $padding/4;
    }
  }
  .list {
    margin-bottom: 2rem;
    h4 {
      color: $col-purple-light;
      margin-bottom: $padding/4;
      @media screen and (max-width: $mq-mobile) {
        margin-bottom: $padding/6;
      }
    }
    ul {
      list-style: none;
      display: flex;
      flex-direction: column;
      li {
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 180%;
        @media screen and (max-width: $mq-mobile) {
          line-height: 130%;
        }
        &::before {
          content: '\2022';
          color: $col-purple-light;
          font-size: 2rem;
          display: inline-block;
          width: 1.5rem;
          transform: translateY(-1px);
          @media screen and (max-width: $mq-mobile) {
            width: 1.2rem;
            font-size: 2rem;
          }
        }
      }
    }
  }
}
</style>
